import { Navigate, Outlet } from 'react-router-dom';
import useUser from '../../hooks/user';
import { useMemo } from 'react';

const ROLE_PATH_MAP: Record<number, string> = {
  0: '/sornthai/dashboard-parent',
  1: '/sornthai/dashboard-parent',
  2: '/sornthai/dashboard-parent',
  3: '/sornthai/dashboard-teacher',
  4: '/sornthai/dashboard-researcher',
  5: '/sornthai/admin/users',
  6: '/sornthai/admin/users',
};

interface ProtectedRouteProps {
  roles?: number[];
}

const ProtectedRoute = ({ roles = [] }: ProtectedRouteProps) => {
  const user = useUser('token');
  const currentRole =
    user?.role !== undefined && user?.role !== null ? Number(user.role) : undefined;

  // Calculate fallback path based on user role
  const fallbackPath = useMemo(() => {
    if (currentRole === undefined || Number.isNaN(currentRole)) return '/signin';
    return ROLE_PATH_MAP[currentRole] || '/signin';
  }, [currentRole]);

  // If user not loaded or doesn't have a role, redirect to signin
  if (!user || currentRole === undefined || Number.isNaN(currentRole)) {
    return <Navigate to="/signin" />;
  }

  // If user role is not in allowed roles, redirect to their default dashboard
  if (roles.length > 0 && !roles.includes(currentRole)) {
    return <Navigate to={fallbackPath} />;
  }

  // User is authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;
